import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["animateOnComplete", "boxShadow", "height", "value"];
import styled, { useTheme } from 'foundations-theming/utils';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { TwoWayTransition } from '../TwoWayTransition';
import { rgba } from '../../utils/color';
import { PlainWrapper } from '../TwoWayTransition/TwoWayTransition';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { filterProps } from '../../../utils/filterProps';
import { MERCURY_LAYER } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const getBoxShadow = (boxShadow, radius, color) => {
  if (typeof boxShadow === 'string') return boxShadow;
  return boxShadow === true ? `0 0 ${radius}px ${rgba(color, 0.4)}` : undefined;
};
const NanoProgressTransitionWrapper = styled(PlainWrapper).withConfig({
  displayName: "NanoProgress__NanoProgressTransitionWrapper"
})(["transition:opacity 200ms ease;opacity:", ";"], ({
  closing
}) => closing ? 0 : 1);
const Bar = styled.div.withConfig({
  displayName: "NanoProgress__Bar"
})(({
  $value,
  $color,
  $height,
  $boxShadow,
  $cssStyles
}) => {
  return Object.assign({
    left: 0,
    position: 'absolute',
    top: 0,
    width: $value != null ? `${$value}%` : '100%',
    zIndex: MERCURY_LAYER,
    background: $color,
    boxShadow: getBoxShadow($boxShadow, $height * 3, $color),
    height: $height,
    transition: 'all 200ms ease'
  }, $cssStyles);
});
export const NanoProgress = _ref => {
  let {
      animateOnComplete = false,
      boxShadow = true,
      height = 2,
      value = 0
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const {
    tokenProps
  } = filterProps(props);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const color = props.color || theme.color['fill-primary-default'];
  return value != null && value >= 0 ? /*#__PURE__*/_jsx(TwoWayTransition, Object.assign({}, props, {
    duration: 200,
    Wrapper: NanoProgressTransitionWrapper,
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: 'NanoProgress',
    children: animateOnComplete && value >= 100 ? null : /*#__PURE__*/_jsx(Bar, {
      "aria-valuemax": 100,
      "aria-valuemin": 0,
      "aria-valuenow": value,
      role: "progressbar",
      $boxShadow: boxShadow,
      $color: color,
      $height: height,
      $value: value,
      $cssStyles: cssStyles
    })
  })) : null;
};
NanoProgress.displayName = 'NanoProgress';